import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {CredentialsTableComponent} from './credentials-table/credentials-table.component';
import {ActionBarModule} from '../../../../components/action-bar/action-bar.module';
import {ArmTableModule} from '../../../../components/arm-table/arm-table.module';
import {CredentialsDialogComponent} from './credentials-dialog/credentials-dialog.component';
import {MaterialModule} from '../../../../material.module';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';



@NgModule({
  exports: [CredentialsTableComponent],
  declarations: [CredentialsTableComponent, CredentialsDialogComponent],
  imports: [
    CommonModule,
    ActionBarModule,
    ArmTableModule,
    MaterialModule,
    FormsModule,
    ReactiveFormsModule
  ]
})
export class CredentialsTableModule { }
